"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H6 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H6",
  componentId: "sc-1v4esg7-0"
})(_templateObject());
H6.propTypes = _Heading.default.propTypes;
H6.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h6'
});
H6.displayName = 'H6';
var _default = H6;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/elements/headings/H6.js
// module id = 186
// module chunks = 5 6